<template>
	<div class="box01">
		<v-crumbs :crumbsType="21"></v-crumbs>
		<div class="offer_top flex02">
			<div class="flex03">
				<div class="btn01 m_r10" @click="$publicFun.get_link('/weixin/parament/help/add', {})">新增</div>
			</div>
		</div>
		<div class="form_box">
			<div style="flex: 1;overflow: hidden;">
				<template>
					<el-table ref="multipleTable" :data="list" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" fixed width="46"></el-table-column>
						<el-table-column prop="id" label="ID" width="70"></el-table-column>
						<el-table-column prop="title" label="标题"></el-table-column>
						<el-table-column prop="createtime_text" label="添加时间"></el-table-column>
						<el-table-column fixed="right" label="操作">
							<template slot-scope="scope">
								<div class="flex04">
									<p class="c_6d9fff m_r10 pointer_" @click="$publicFun.get_link('/weixin/parament/help/add?id=' + scope.row.id, {})">编辑</p>
									<p class="c_ff6f6f pointer_" @click="get_del(scope.row)">删除</p>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</template>
			</div>
			<div class="form_right_nav_wrapper">
				<v-right-nav :index="2"></v-right-nav>
			</div>
		</div>
		<div class="pagination">
			<el-pagination background :page-size="formInfo.limit" :current-page="formInfo.page" layout="prev, pager, next, jumper"
			 :total="total" @current-change="currentChange"></el-pagination>
		</div>
	</div>
</template>

<script>
	import modal from '../../components/wx-modal/index.vue'; // 弹窗
	import crumbs from '../../components/crumbs/index.vue'; // 面包屑
	import rightNav from '../../components/wx-nav/index.vue'; // 右侧导航

	import {
		helpList,
		helpShow,
		helpAdd,
		helpEdit,
		helpDel
	} from '@/api/index';

	export default {
		components: {
			'v-modal': modal,
			'v-crumbs': crumbs,
			'v-right-nav': rightNav
		},
		data() {
			return {
				list: [],
				total: null,
				detail_info: {},
				dialogVisible: false,
				formInfo: {
					page: 1,
					limit: 10
				},
			}
		},
		created() {
			this.get_help_list();
		},
		methods: {
			// 帮助中心列表
			get_help_list() {
				helpList(this.formInfo).then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				})
			},
			// 点击页码数
			currentChange(newPage) {
				this.formInfo.page = newPage;
				this.get_help_list();
				window.scroll(0, 0);
			},
			// 删除
			get_del(e) {
				this.$confirm('确定删除吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					helpDel({
						id: e.id
					}).then(res => {
						if (this.formInfo.page != 1 && this.list.length == 1) {
							this.formInfo.page--
						}
						this.get_help_list();
						this.$message.success('删除成功');
					})
				})
			},
			handleSelectionChange(e) {

			},
		}
	}
</script>

<style lang="less" scoped>
	.offer_top {
		margin-bottom: 15px;
	}

	/deep/ .form_box {
		display: flex;

		tr {
			td {
				padding: 20px 0;
			}
		}
	}

	/deep/ .el-image {
		margin: 6px auto;
	}
</style>
